import security from 'stores/security';
import { AccountCustomerTypeEnum } from 'types/user';

export const getTitleByCustomerType = () => {
    switch (security.currentAccount!.customerType) {
        case AccountCustomerTypeEnum.IRA_ROTH:
            return __('Contribute to your Roth IRA');
        case AccountCustomerTypeEnum.IRA_TRADITIONAL:
            return __('Contribute to your Traditional IRA');
        case AccountCustomerTypeEnum.IRA_ROLLOVER:
            return __('Contribute to your Rollover IRA');
        default:
            return __('ACH Deposit');
    }
};
